import React, { Component, Fragment, useEffect } from 'react';
import { elements } from './_data_safety_layout';
import DaySafetyElement from './DaySafetyElement';
import '@app/components/sqdp/iqc/styles/safety-layout.css';
import dayjs from 'dayjs';
import { getDayColorError, getDayColorGood, getDayColorWarn } from '@app/services/localStorage.service';

class SafetyLayout extends Component {
  // constructor(){
  //   this.childSetClickedFunc = React.useRef(null)
  // }
  state = {
    showInfo: false,
    element: {},
    // items: []
    // lastClickedElement: 0
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 1, 'iqc');
  };

  getColorOfDay = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0)) {
        // if(issueOfDay.countDeliveryTotal <=0 && issueOfDay.countProductivityTotal <=0 && issueOfDay.countQualityTotal <=0){
        return 'emtpy_state';
      }

      if (!issueOfDay.countSafetyTotal || issueOfDay.countSafetyTotal <= 0) {
        // console.log('datenum and dayjs ', dateNum,   dayjs().get('date'))

        let today = dayjs();
        let selectedTime = dayjs(this.props.selectedMonth);
        // console.log('today month and year  ', today.get('month'),  today.get('year'))
        // console.log('selectedTime month and year  ', selectedTime.get('month'),  selectedTime.get('year'))
        if (
          today.get('month') <= selectedTime.get('month') &&
          today.get('year') <= selectedTime.get('year') &&
          dateNum == today.get('date')
        ) {
          return 'emtpy_state';
        }

        // if((!issueOfDay.countProductivityTotal || issueOfDay.countProductivityTotal <=0 ) && (!issueOfDay.countDeliveryTotal || issueOfDay.countDeliveryTotal <=0 ) && (!issueOfDay.countQualityTotal || issueOfDay.countQualityTotal <=0 )){
        //   let toDayInWeek = today.day();
        //   if(toDayInWeek == 6 || toDayInWeek ==0){
        //     return 'emtpy_state';
        //   }
        // }

        return 'green_state';
      }

      if (!issueOfDay.countSafetyIsAccident || issueOfDay.countSafetyIsAccident <= 0) {
        return 'yellow_state';
      }

      if (issueOfDay.countSafetyIsAccident > 0) {
        return 'red_state';
      }
    }

    return 'emtpy_state';
  };

  // closeInfo = () => {
  //   this.props.setState({ showInfo: false, element: {} })
  // }

  /**
   * Helper method that will generate a number of elements
   * from start index to end index to avoid copy pasting
   * all the hundred elements
   * @param {number} start
   * @param {number} end
   * @return {Array<Object>}
   */
  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDay = this.props.dataInMonth[i - 1];
      let color = this.getColorOfDay(issueOfDay, i);
      items.push(
        <DaySafetyElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          color={color}
          num={i}
          issues={issueOfDay ? issueOfDay : {}}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-safety">{this.populateElements(1, 32)}</div>
        <h3 className="center" style={{ marginTop: '20px' }}>
          Safety
        </h3>
      </>
    );
  }
}

export default SafetyLayout;
